import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Container,
  Box,
  Card,
  CardMedia,
  CardContent,
  Button,
  CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const MenuDetail = () => {
  const [menuItem, setMenuItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const { menuId } = useParams();
  const { addToCart } = useCart();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    const fetchMenuItem = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/menu/${menuId}`
        );
        const data = await response.json();
        setMenuItem(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching menu details", error);
      }
    };

    fetchMenuItem();
  }, [menuId]);

  const handleAddToCart = (event, item) => {
    event.stopPropagation();
    addToCart(item, 1);
    setSnackbarMessage(`${item.name} added to cart!`);
    setSnackbarOpen(true);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Link to="/menu" variant="body2">
        <Typography variant="body1" sx={{ mb: 2 }}>
          Back to menu
        </Typography>
      </Link>

      <Card raised sx={{ maxWidth: "100%", padding: 2 }}>
        <CardMedia
          component="img"
          image={menuItem.image}
          // image={`http://localhost:3001/${menuItem.image}`}
          alt={`${menuItem.name}`}
          sx={{ width: "100%", height: "auto" }}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {menuItem.name}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginY: 2,
            }}
          >
            <Typography variant="subtitle1">{menuItem.description}</Typography>
            <Typography variant="h4">₹{menuItem.price}</Typography>
          </Box>

          <Button
            size="small"
            variant="outlined"
            fullWidth
            onClick={(event) => handleAddToCart(event, menuItem)}
            sx={{
              ":hover": {
                bgcolor: "primary.main",
                color: "white",
                border: "1px solid rgba(0, 0, 0, 0.23)",
              },
            }}
          >
            Add to cart
          </Button>
        </CardContent>
      </Card>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default MenuDetail;
